import { render, staticRenderFns } from "./AgendaForm.vue?vue&type=template&id=320753a2&scoped=true"
import script from "./AgendaForm.vue?vue&type=script&lang=js"
export * from "./AgendaForm.vue?vue&type=script&lang=js"
import style0 from "./AgendaForm.vue?vue&type=style&index=0&id=320753a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320753a2",
  null
  
)

export default component.exports